import axios        from "axios";
import Toaster      from "./toaster";
import { debounce } from 'lodash-es';

export default class AdfFolders
{
    constructor ()
    {

        this.btnActionTogglerMobile = document.querySelector( '.profile-single-folder .btn-toggle-folder-actions' );
        this.isSingleFolderPage     = document.body.classList.contains( 'profile-single-folder' );

        this.createClosure();
        this.bindEvents();

        // only applies to folders-single
        if ( this.isSingleFolderPage )
        {
            this.bindActionTogglerMobileEvents();
            this.sizeChanged();
        }

    }

    createClosure ()
    {
        this.fctOnShare     = this.onShare.bind( this );
        this.fctOnRename    = this.onRename.bind( this );
        this.fctOnDuplicate = this.onDuplicate.bind( this );
        this.fctOnDelete    = this.onDelete.bind( this );
        this.fctOnCreate    = this.onCreate.bind( this );

        this.fctOnDidRename  = this.onDidRename.bind( this );
        this.fctOnDidDelete  = this.onDidDelete.bind( this );
        this.fctOnDidShare   = this.onDidShare.bind( this );
        this.fctOnDidCopyUrl = this.onDidCopyUrl.bind( this );
    }

    bindEvents ()
    {
        this.setClickOnButton( "rename", this.fctOnRename );
        this.setClickOnButton( "delete", this.fctOnDelete );
        this.setClickOnButton( "share", this.fctOnShare );
        this.setClickOnButton( "create", this.fctOnCreate );
        this.setClickOnButton( "duplicate", this.fctOnDuplicate );

        window.addEventListener( "rename-folder", this.fctOnDidRename );
        window.addEventListener( "delete-folder", this.fctOnDidDelete );
        window.addEventListener( "share-folder", this.fctOnDidShare );
        window.addEventListener( "copy-folder-url", this.fctOnDidCopyUrl );
        window.addEventListener( "share-folder", this.fctOnDidShare );


    }


    setClickOnButton ( strType, fct )
    {
        let allBtns = Array.from( document.querySelectorAll( `[data-button='${strType}']` ) );
        allBtns.forEach( btn => btn.addEventListener( "click", fct ) );
    }

    onShare ( e )
    {
        let target = e.target;
        let parent = target.closest( "[data-button-parent]" );

        let id   = parent.attributes[ "data-folder-id" ].value;
        let name = parent.attributes[ "data-folder-name" ].value;
        let url  = parent.attributes[ "data-folder-url" ].value;

        if ( window.__login__ )
        {
            window.__login__.show( "share-folder", { id, name, url } );
        }
    }

    onDidShare ( e )
    {
        Toaster.fire( e.detail.message )
    }

    onDidCopyUrl ( e )
    {
        Toaster.fire( e.detail.message )
    }

    onRename ( e )
    {
        let target = e.target;
        let parent = target.closest( "[data-button-parent]" );

        let id   = parent.attributes[ "data-folder-id" ].value;
        let name = parent.attributes[ "data-folder-name" ].value;

        if ( window.__login__ )
        {
            window.__login__.show( "rename-folder", { id, name } );
        }


    }

    async onDidRename ( e )
    {
        document.activeElement.blur();
        await Toaster.fire( e.detail.message );

        let title  = document.querySelector( `[data-folder-name-id='${e.detail.id_folder}']` );
        let parent = document.querySelector( `[data-button-parent][data-folder-id='${e.detail.id_folder}']` );

        if ( title )
        {


            title.textContent = e.detail.name;

            if ( parent )
            {
                parent.attributes[ "data-folder-name" ].value = e.detail.name;
            }


            window.location.reload()
        } else
        {
            window.location.reload();
        }
    }

    async onDuplicate ( e )
    {
        let target = e.target;
        let parent = target.closest( "[data-button-parent]" );

        let id_folder = parent.attributes[ "data-folder-id" ].value;

        let payload  = { id_folder };
        let response = await axios.post( "/endpoints/duplicate/folder", payload );
        //let name = parent.attributes["data-folder-name"].value;


        await this.onDidDuplicate( response.data )
    }

    async onDidDuplicate ( response ) // <-- not an event
    {

        let strPageType = document.querySelector( "body" ).attributes[ "data-page-id" ].value;

        await Toaster.fire( response.message );

        if ( strPageType === "folders" )
        {
            window.location.reload();
        }


    }


    onDelete ( e )
    {
        let target = e.target;
        let parent = target.closest( "[data-button-parent]" );


        let id   = parent.attributes[ "data-folder-id" ].value;
        let name = parent.attributes[ "data-folder-name" ].value;

        if ( window.__login__ )
        {
            window.__login__.show( "delete-folder", { id, name } );
        }

    }

    async onDidDelete ( e )
    {
        let card        = document.querySelector( `[data-folder-id='${e.detail.id_folder}']` );
        let strPageType = document.querySelector( "body" ).attributes[ "data-page-id" ].value;

        await Toaster.fire( e.detail.message )

        if ( card && strPageType === "folders" )
        {
            card.remove();
        } else
        {
            window.location.href = e.detail.url;
        }
    }


    onCreate ( e )
    {
        let target = e.target;
        let parent = target.closest( "[data-button-parent]" );

        if ( window.__login__ )
        {
            window.__login__.show( "rename-folder", { id : 0, name : "", type : "create" } );
        }
    }


    bindActionTogglerMobileEvents ()
    {

        this.folderActionButtonsOpen      = false;
        this.folderActionButtonsContainer = document.querySelector( '.folder-action-buttons' );
        this.folderActionButtonsBg        = this.folderActionButtonsContainer.querySelector( '.bg' );
        this.folderActionInnerContainer   = this.folderActionButtonsContainer.querySelector( '.buttons-container' );

        this.btnActionTogglerMobile.addEventListener( 'click', e =>
        {
            if ( this.folderActionButtonsOpen )
            {
                this.hideFolderActionButtons();
            } else
            {
                this.showFolderActionButtons();
            }
        } );


        this.folderActionButtonsBg.addEventListener( 'click', this.hideFolderActionButtons.bind( this ) );

        window.addEventListener( 'resize', debounce( () =>
        {
            this.sizeChanged();
        }, 200 ) );
    }

    showFolderActionButtons ()
    {
        this.folderActionButtonsContainer.classList.add( 'open' );

        this.folderActionInnerContainer.classList.remove( 'animate__slideOutDown', 'animate__animated' );
        this.folderActionInnerContainer.classList.add( 'animate__slideInUp', 'animate__animated' );

        this.folderActionButtonsBg.classList.remove( 'animate__fadeOut', 'animate__animated' );
        this.folderActionButtonsBg.classList.add( 'animate__fadeIn', 'animate__animated' );

        this.folderActionButtonsOpen = true;
    }

    hideFolderActionButtons ()
    {
        this.folderActionInnerContainer.classList.remove( 'animate__animated', 'animate__slideInUp' );
        this.folderActionInnerContainer.classList.add( 'animate__slideOutDown', 'animate__animated' );

        this.folderActionButtonsBg.classList.remove( 'animate__fadeIn', 'animate__animated' );
        this.folderActionButtonsBg.classList.add( 'animate__fadeOut', 'animate__animated' );

        setTimeout( () =>
        {
            this.folderActionButtonsContainer.classList.remove( 'open' );
        }, 150 )
        this.folderActionButtonsOpen = false;

    }


    sizeChanged ()
    {
        const currentMode = window.innerWidth < 768 ? 'mobile' : 'desktop';



        // we only care about switching modes
        if ( typeof this.currentMode !== 'undefined' && currentMode === this.currentMode )
        {

/*console.log(('Size changed, but remained in ' + currentMode))*/;
            return;
        }



        this.currentMode = currentMode;

/*console.log(('Size changed. Now in ' + currentMode + ' mode.'))*/;
        if ( 'mobile' === this.currentMode )
        {
            this.resetMobile();
        } else
        {
            this.resetDesktop();
        }

    }

    resetMobile ()
    {
        this.folderActionButtonsOpen = false;
        this.hideFolderActionButtons();
    }

    resetDesktop ()
    {
        this.folderActionButtonsBg.classList.remove('animate__animated');
        this.folderActionInnerContainer.classList.remove('animate__animated');
        this.folderActionButtonsOpen = false;
    }
}
